import React, { CSSProperties, FC, MouseEvent, ReactNode } from 'react'
import { onClick } from 'helpers/fastClick'
import { PreloadImage, StyledButton, LoadingWrapper } from './styled'

export interface ButtonStyledProps {
  padding?: string
  minWidth?: string
  float?: boolean
  minHeight?: boolean
  noBorderRadius?: boolean
  xtra_sssm?: boolean
  xtra_ssm?: boolean
  xtra_sm?: boolean
  sm?: boolean
  md?: boolean
  md2?: boolean
  md3?: boolean
  lg?: boolean
  lgRequired?: boolean
  inputSize?: boolean
  inputSizeSearch?: boolean
  inputBorderRadius?: boolean
  onlyIcon?: boolean
  flexWrap?: boolean
  alignTop?: boolean
  fullContent?: boolean
  left?: boolean
  isProcessing?: boolean
  disabled?: boolean
  outline?: boolean
  gray?: boolean
  darkGrey?: boolean
  secondary?: boolean
  warning?: boolean
  outlineGreen?: boolean
  outlineWhite?: boolean
  lgWarning?: boolean
  noOutLine?: boolean
  noOutLineWhite?: boolean
  outlineError?: boolean
  error?: boolean
}

export interface ButtonProps extends ButtonStyledProps {
  children: ReactNode
  onClick?: (event: MouseEvent<HTMLButtonElement>) => void
  enableFastClick?: boolean
  id?: string
  className?: string
  type?: string
  title?: boolean
  style?: CSSProperties
  bold?: boolean
  testId?: string
}

const Button: FC<ButtonProps> = ({
  children,
  isProcessing = false,
  noBorderRadius = false,
  onlyIcon = false,
  fullContent = false,
  onClick: btnOnClick = () => {},
  enableFastClick = false,
  disabled = false,
  noOutLine = false,
  type,
  title,
  testId,
  ...rest
}) => {
  let clickObj = {}
  if (btnOnClick) {
    clickObj = enableFastClick ? { ...onClick((e) => btnOnClick(e)) } : { onClick: btnOnClick }
  }

  return (
    <StyledButton
      data-testid={testId}
      {...rest}
      {...clickObj}
      noBorderRadius={noBorderRadius}
      onlyIcon={onlyIcon}
      disabled={disabled}
      isProcessing={isProcessing}
      fullContent={fullContent}
      noOutLine={noOutLine}
    >
      <PreloadImage src={`${process.env.PUBLIC_URL}/assets/loading/loading-white.svg`} />
      {isProcessing ? (
        noOutLine ? (
          <LoadingWrapper>
            <svg
              width="30px"
              height="30px"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 100 100"
              preserveAspectRatio="xMidYMid"
              className="lds-rolling"
            >
              <circle
                cx="50"
                cy="50"
                fill="none"
                ng-attr-stroke="{{config.color}}"
                ng-attr-stroke-width="{{config.width}}"
                ng-attr-r="{{config.radius}}"
                ng-attr-stroke-dasharray="{{config.dasharray}}"
                stroke="#fff"
                strokeWidth="10"
                r="35"
                strokeDasharray="164.93361431346415 56.97787143782138"
                transform="rotate(162 50 50)"
              >
                <animateTransform
                  attributeName="transform"
                  type="rotate"
                  calcMode="linear"
                  values="0 50 50;360 50 50"
                  keyTimes="0;1"
                  dur="400ms"
                  begin="0s"
                  repeatCount="indefinite"
                ></animateTransform>
              </circle>
            </svg>
          </LoadingWrapper>
        ) : (
          <img src={`${process.env.PUBLIC_URL}/assets/loading/loading-white.svg`} width="30px" height="28px" alt="" />
        )
      ) : (
        <div className="content-wrapper">{children}</div>
      )}
    </StyledButton>
  )
}

export default Button
